import { render } from "./psp-limits-settings.vue?vue&type=template&id=2e5b1d42&ts=true"
import script from "./psp-limits-settings.ts?vue&type=script&lang=ts"
export * from "./psp-limits-settings.ts?vue&type=script&lang=ts"

import "./psp-limits-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__